/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'; // Import createRoot
import GridCustomDropdown from './GridCustomDropdown';

// Helper to read the column definition for the current cell and return its source list
const getSourceForCell = (cell) => {
  if (!cell) return [];
  const table = cell.closest('.jexcel');
  const jspInstance = table && table.jspreadsheet;
  if (!jspInstance) return [];
  const columnIndex = Number(cell.dataset?.x);
  const columnDefinition = jspInstance.options?.columns?.[columnIndex] || {};
  return columnDefinition.source || [];
};

const customColumn = {
  openEditor(cell, instance) {
    // Cleanup previous contents including React components
    while (cell.firstChild) {
      cell.removeChild(cell.firstChild);
    }

    // get source for this column from options.customDropdownSources by checking column name first and referencing it there
    // get column id from options.columns
    const { columns } = instance.jspreadsheet.options;
    const thisColumn = columns[cell.dataset.x];

    // get source values for this column from column definition
    const source = thisColumn.source || []; // expects [{ id, name }, ...]

    const rowIndex = Number(cell.dataset.y);
    const columnIndex = Number(cell.dataset.x);
    // Prefer the staged dataset value, fallback to the persisted spreadsheet value
    const currentValue = cell.dataset.value ?? (instance?.jspreadsheet?.options?.data?.[rowIndex]?.[columnIndex] != null ? String(instance.jspreadsheet.options.data[rowIndex][columnIndex]) : '');

    // Create a container for the React component
    const container = document.createElement('div');
    cell.appendChild(container);

    // Create a root container if it doesn't already exist
    const root = createRoot(container); // createRoot instead of render
    cell._rootContainer = root; // Store the root on the cell for later unmounting

    // Render the React component
    root.render(
      <GridCustomDropdown
        initialValue={currentValue}
        source={source}
        onSave={(newValue) => {
          const nextValue = newValue != null ? String(newValue) : '';
          instance.jspreadsheet.setValue(cell, nextValue, true); // Persist the selected id immediately
          instance.jspreadsheet.closeEditor(cell, true);
        }}
      />,
    );
  },
  closeEditor(cell, save) {
    if (cell.firstChild) {
      cell.firstChild.onblur = null;
    }
    if (cell._rootContainer) {
      try {
        cell._rootContainer.unmount(); // Unmount using the root
        cell.removeChild(cell.firstChild); // Cleanup the React container
      } catch (err) {
        console.log('Error unmounting React component:', err);
      }
    }
    // Replace the cell contents with the matching display label after React unmounts
    const source = getSourceForCell(cell);
    const displayValue = source.find((option) => option.id === cell.dataset.value)?.name || cell.dataset.value || '';
    console.log('DEBUG', displayValue, source, cell.dataset.value);
    cell.innerHTML = displayValue; // Display friendly label
    if (save && cell.dataset.value) {
      return cell.dataset.value; // save id in jspreadsheet state
    }
    return null;
  },

  getValue(cell) {
    return cell.dataset.value || ''; // Retrieve the value from data attribute
  },

  // this sets the visible value
  setValue(cell, value) {
    const source = getSourceForCell(cell);
    const stringValue = value != null ? String(value) : '';
    cell.dataset.value = stringValue; // Store the new value in a data attribute
    cell.innerHTML = source.find((option) => option.id === stringValue)?.name || stringValue; // Display friendly label
  },
};

export default customColumn;
